module.exports = __webpack_public_path__ + "img/disaster_relief-detail.87893eba.jpg";